// src/MediumIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MediumIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "14",
    viewBox: "0 0 24 14",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.95563 13.9825H5.60969C3.41369 13.5243 1.52177 12.1388 0.605315 10.0896C0.309063 9.42772 0.157324 8.72988 0.0140145 8.02366C0.0294665 7.79451 0.0203056 7.55399 0.0111526 7.31369C0.00104507 7.04832 -0.00905283 6.78321 0.0140145 6.53393C0.674561 -0.562467 10.9194 -1.81199 13.2207 5.10291C14.4581 8.82153 12.0062 13.5015 7.95563 13.9825Z",
          fill: "#016FB9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.2658 0.887119C19.69 0.507949 20.8413 4.40267 20.9539 6.20388C21.0834 8.27883 20.642 12.8702 18.1721 13.5836C15.5804 14.3324 14.4009 10.1321 14.2702 8.2944C14.1269 6.27816 14.6525 1.29564 17.2652 0.887119H17.2658Z",
          fill: "#016FB9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M23.5336 2.69491C23.4378 2.36426 23.1452 1.40166 22.6791 1.53883C22.4967 1.59274 22.3196 1.95813 22.2462 2.12526C21.3616 4.13731 21.2828 10.7174 22.3461 12.6312C22.6159 13.1176 22.9567 13.117 23.2271 12.6312C24.2724 10.7515 24.1363 4.77405 23.5336 2.69491Z",
          fill: "#016FB9"
        }
      )
    ]
  }
);
var MediumIcon_default = MediumIcon;

export {
  MediumIcon_default
};
